__webpack_require__.p = "/amis-wordle/";